"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialMediaImageProperty = exports.socialMediaImagePropertyDefinition = void 0;
exports.socialMediaImagePropertyDefinition = {
    view: {
        label: 'Social media image',
        hint: 'This image will be used if the content is shared on Facebook or Twitter. Use images that capture the users attention in the crowded social media environment and consider the branding guidelines.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'social-media-image',
};
const isSocialMediaImageProperty = (prop) => {
    return prop.name === exports.socialMediaImagePropertyDefinition.name;
};
exports.isSocialMediaImageProperty = isSocialMediaImageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsLW1lZGlhLWltYWdlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc29jaWFsLW1lZGlhLWltYWdlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLG9CQUFvQjtRQUMzQixJQUFJLEVBQUUsb01BQW9NO0tBQzNNO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUM7U0FDcEI7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsb0JBQW9CO0NBQ0ssQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9